"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialWidget = exports.formatUsd = void 0;
const core_1 = require("@material-ui/core");
const Chart = require("chart.js");
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/orders/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const dashboard_1 = require("shared/dashboard");
require("./financial-widget.less");
const moment = require("moment");
;
exports.formatUsd = (amount) => new Intl.NumberFormat("en-us", { style: "currency", currency: "usd" }).format(amount);
const styles = (theme) => core_1.createStyles({
    btnContainer: {
        display: "flex",
        justifyContent: "space-between",
        padding: "1rem",
        alignItems: "center"
    },
    priceLabel: {
        display: "flex",
        alignItems: "center"
    },
    label: {
        fontSize: "1rem",
        marginRight: 10
    },
    value: {
        fontSize: 20,
        fontWeight: 300,
        backgroundColor: "#f2f2f2"
    },
    tableHead: {
        width: "auto",
        height: "95px",
        backgroundColor: "#e9ebf1"
    },
    header: {
        background: "#d2d7e2",
        borderRadius: "5px"
    },
    root: {
        borderCollapse: "separate",
        borderSpacing: 2
    }
});
let FinancialWidgetUnstyled = class FinancialWidgetUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.payPeriod = dashboard_1.PayPeriod.Daily;
        this.claimDataIndexToFill = [];
        this.claimDispensedDataIndexToFill = [];
        this.orderDataIndexToFill = [];
        this.myBarChart = null;
        this.siteId = 0;
        this.siteIdArray = [];
        this.listFinancialData = async () => {
            const query = {
                siteId: Array.from(this.siteIdArray),
                payPeriod: this.payPeriod
            };
            try {
                await Promise.all([
                    store_2.ordersStore.listClaimsWithinDateRange(query),
                    store_2.ordersStore.listDispensedClaimsWithinDateRange(query),
                    store_1.inventoryOrderStore.listPurchaseOrdersWithinDateRange(query)
                ]);
            }
            catch (err) {
                console.error("Error in querying claims and POs for financial graph");
            }
        };
        this.getDefaultDaily = () => Array(7)
            .fill(null)
            .map((val, index) => moment(new Date())
            .subtract(index, "day")
            .format("MMM D"))
            .reverse();
        this.getDefaultWeekly = () => Array(6)
            .fill(null)
            .map((val, index) => moment(new Date())
            .subtract(index, "week")
            .startOf("week")
            .format("MMM D"))
            .reverse();
        this.getDefaultMonthly = () => Array(3)
            .fill(null)
            .map((val, index) => moment(new Date())
            .subtract(index, "month")
            .format("MMMM"))
            .reverse();
        this.getDefaultYearly = () => Array(2)
            .fill(null)
            .map((val, index) => moment(new Date())
            .subtract(index, "year")
            .format("YYYY"))
            .reverse();
        this.getDefaultLabels = () => {
            switch (this.payPeriod) {
                case dashboard_1.PayPeriod.Daily:
                    return this.getDefaultDaily();
                case dashboard_1.PayPeriod.Weekly:
                    return this.getDefaultWeekly();
                case dashboard_1.PayPeriod.Monthly:
                    return this.getDefaultMonthly();
                case dashboard_1.PayPeriod.Yearly:
                    return this.getDefaultYearly();
                default:
                    return [];
            }
        };
        this.getChartLabels = () => {
            const defaultLabels = this.getDefaultLabels();
            const claimLabels = store_2.ordersStore.financialClaims.map(claim => {
                switch (this.payPeriod) {
                    case dashboard_1.PayPeriod.Daily:
                        return moment(claim.date).format("MMM D");
                    case dashboard_1.PayPeriod.Weekly: {
                        const sow = moment(claim.date)
                            .startOf("week")
                            .format("MMM D");
                        return `${sow}`;
                    }
                    case dashboard_1.PayPeriod.Monthly:
                        return moment(claim.date).format("MMMM");
                    case dashboard_1.PayPeriod.Yearly:
                        return moment(claim.date).format("YYYY");
                    default:
                        console.log("Defaulting to daily");
                        return moment(claim.date).format("M-D-YYYY");
                }
            });
            const claimDispensedLabels = store_2.ordersStore.financialClaimsDispensed.map(claim => {
                switch (this.payPeriod) {
                    case dashboard_1.PayPeriod.Daily:
                        return moment(claim.date).format("MMM D");
                    case dashboard_1.PayPeriod.Weekly: {
                        const sow = moment(claim.date)
                            .startOf("week")
                            .format("MMM D");
                        return `${sow}`;
                    }
                    case dashboard_1.PayPeriod.Monthly:
                        return moment(claim.date).format("MMMM");
                    case dashboard_1.PayPeriod.Yearly:
                        return moment(claim.date).format("YYYY");
                    default:
                        console.log("Defaulting to daily");
                        return moment(claim.date).format("M-D-YYYY");
                }
            });
            const orderLabels = store_1.inventoryOrderStore.financialPurchaseOrders.map(po => {
                switch (this.payPeriod) {
                    case dashboard_1.PayPeriod.Daily:
                        return moment(po.approvalDate).format("MMM D");
                    case dashboard_1.PayPeriod.Weekly: {
                        const sow = moment(po.approvalDate)
                            .startOf("week")
                            .format("MMM D");
                        return `${sow}`;
                    }
                    case dashboard_1.PayPeriod.Monthly:
                        return moment(po.approvalDate).format("MMMM");
                    case dashboard_1.PayPeriod.Yearly:
                        return moment(po.approvalDate).format("YYYY");
                    default:
                        console.log("Defaulting to daily");
                        return moment(po.approvalDate).format("M-D-YYYY");
                }
            });
            this.resetIndexToFill();
            for (const label of defaultLabels) {
                if (!claimLabels.includes(label)) {
                    this.claimDataIndexToFill.push(defaultLabels.indexOf(label));
                }
                if (!claimDispensedLabels.includes(label)) {
                    this.claimDispensedDataIndexToFill.push(defaultLabels.indexOf(label));
                }
                if (!orderLabels.includes(label)) {
                    this.orderDataIndexToFill.push(defaultLabels.indexOf(label));
                }
            }
            return defaultLabels;
        };
        this.resetIndexToFill = () => {
            this.claimDataIndexToFill = [];
            this.claimDispensedDataIndexToFill = [];
            this.orderDataIndexToFill = [];
        };
        this.getChartData = (field) => {
            switch (field) {
                case "dispense": {
                    const dispensedClaimData = store_2.ordersStore.financialClaimsDispensed.map(claim => Number(claim.sumOfTotalAmount.toFixed(2)));
                    for (const index of this.claimDispensedDataIndexToFill) {
                        dispensedClaimData.splice(index, 0, 0);
                    }
                    return dispensedClaimData;
                }
                case "order": {
                    const orderData = store_1.inventoryOrderStore.financialPurchaseOrders.map(po => po.sumOfOrderTotalCost);
                    for (const index of this.orderDataIndexToFill) {
                        orderData.splice(index, 0, 0);
                    }
                    return orderData;
                }
                case "reimbursement": {
                    const allClaimsData = store_2.ordersStore.financialClaims.map(claim => Number(claim.sumOfTotalAmount.toFixed(2)));
                    for (const index of this.claimDataIndexToFill) {
                        allClaimsData.splice(index, 0, 0);
                    }
                    return allClaimsData;
                }
                default:
                    return [];
            }
        };
        this.renderFinancialChart = () => {
            const data = {
                labels: this.getChartLabels(),
                datasets: [
                    {
                        // label: "Dispenses",
                        label: "Dispense Value",
                        backgroundColor: dashboard_1.ChartColor.Dispense,
                        data: this.getChartData("dispense")
                    },
                    {
                        // label: "Orders",
                        label: "Product Orders",
                        backgroundColor: dashboard_1.ChartColor.Order,
                        data: this.getChartData("order")
                    },
                    {
                        // label: "Reimbursement",
                        label: "Production Potential",
                        backgroundColor: dashboard_1.ChartColor.Reimbursement,
                        data: this.getChartData("reimbursement")
                    }
                ]
            };
            const options = {
                responsive: true,
                maintainAspectRatio: true,
                legend: { display: true },
                title: {
                    display: true,
                    // text: "Dispense, Order and Reimbursement"
                    text: "Dispenses, Product Orders and Production Potential"
                },
                tooltips: {
                    callbacks: {
                        label(t, d) {
                            const yLabel = d.datasets[t.datasetIndex].label;
                            const xLabel = exports.formatUsd(d.datasets[t.datasetIndex].data[t.index]);
                            return yLabel + ": " + xLabel;
                        }
                    }
                },
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                callback(value, index, values) {
                                    if (parseInt(value, 10) >= 1000) {
                                        return ("$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                    }
                                    else if (value < 0) {
                                        if (parseInt(value, 10) <= 1000) {
                                            return ("-$" + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                        }
                                        else {
                                            return "-$" + Math.abs(value);
                                        }
                                    }
                                    else {
                                        return "$" + value;
                                    }
                                }
                            }
                        }
                    ]
                }
            };
            const ctx = this.refs.financialWidget;
            ctx.getContext("2d");
            if (this.myBarChart) {
                this.myBarChart.destroy();
            }
            this.myBarChart = new Chart(ctx, {
                type: "horizontalBar",
                data,
                options
            });
        };
        this.renderFinancialPeriodChart = () => {
            // console.log("period data in chart fun:", this.periodData);
            const periodDataDispenses = [];
            periodDataDispenses.push(this.prevPeriodData.dispenses);
            periodDataDispenses.push(this.periodData.dispenses);
            const periodDataOrders = [];
            periodDataOrders.push(this.prevPeriodData.orders);
            periodDataOrders.push(this.periodData.orders);
            const periodDataProdPotential = [];
            periodDataProdPotential.push(this.prevPeriodData.productionPotential);
            periodDataProdPotential.push(this.periodData.productionPotential);
            const periodLabels = [];
            periodLabels.push(this.prevPeriodDateRange);
            periodLabels.push(this.periodDateRange);
            const data = {
                labels: periodLabels,
                datasets: [
                    {
                        label: "Dispense Value",
                        backgroundColor: dashboard_1.ChartColor.Dispense,
                        data: periodDataDispenses
                    },
                    {
                        label: "Product Orders",
                        backgroundColor: dashboard_1.ChartColor.Order,
                        data: periodDataOrders
                    },
                    {
                        label: "Production Potential",
                        backgroundColor: dashboard_1.ChartColor.Reimbursement,
                        data: periodDataProdPotential
                    }
                ]
            };
            const options = {
                responsive: true,
                maintainAspectRatio: true,
                legend: { display: true },
                title: {
                    display: true,
                    // text: "Dispense, Order and Reimbursement"
                    text: "Dispenses, Product Orders and Production Potential"
                },
                tooltips: {
                    callbacks: {
                        label(t, d) {
                            const yLabel = d.datasets[t.datasetIndex].label;
                            const xLabel = exports.formatUsd(d.datasets[t.datasetIndex].data[t.index]);
                            return yLabel + ": " + xLabel;
                        }
                    }
                },
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                callback(value, index, values) {
                                    if (parseInt(value, 10) >= 1000) {
                                        return ("$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                    }
                                    else if (value < 0) {
                                        if (parseInt(value, 10) <= 1000) {
                                            return ("-$" + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                        }
                                        else {
                                            return "-$" + Math.abs(value);
                                        }
                                    }
                                    else {
                                        return "$" + value;
                                    }
                                }
                            }
                        }
                    ]
                }
            };
            const ctx = this.refs.financialPeriodWidget;
            ctx.getContext("2d");
            if (this.myBarChart) {
                this.myBarChart.destroy();
            }
            this.myBarChart = new Chart(ctx, {
                type: "horizontalBar",
                data,
                options
            });
        };
        this.handleChangePeriod = async (id) => {
            this.payPeriod = Number(id);
            await this.listFinancialData();
            this.renderFinancialChart();
        };
        this.handleChangeSite = async (id) => {
            this.siteId = Number(id);
            this.siteIdArray = [];
            if (this.siteId === 0) {
                this.siteIdArray = store_3.sitesListStore.sites.value.map((site) => {
                    if (!site.testClinic)
                        return site.id;
                }).filter(e => !!e);
            }
            else {
                this.siteIdArray.push(this.siteId);
            }
            await this.listFinancialData();
            if (!this.props.isFinancialPage) {
                this.renderFinancialChart();
            }
        };
    }
    get availableOptions() {
        return [
            {
                id: dashboard_1.PayPeriod.Daily,
                label: "Daily",
                value: dashboard_1.PayPeriod.Daily.toString()
            },
            {
                id: dashboard_1.PayPeriod.Weekly,
                label: "Weekly",
                value: dashboard_1.PayPeriod.Weekly.toString()
            },
            {
                id: dashboard_1.PayPeriod.Monthly,
                label: "Monthly",
                value: dashboard_1.PayPeriod.Monthly.toString()
            },
            {
                id: dashboard_1.PayPeriod.Yearly,
                label: "Yearly",
                value: dashboard_1.PayPeriod.Yearly.toString()
            }
        ];
    }
    get availableOptionsSites() {
        // const options: IMenuItem[] = [];
        // const isImbUser = usersStore.user.value.user;
        // if (isImbUser) {
        //   if (sitesListStore.sites.value) {
        //     options.push({ id: 0, label: "All Pharmacies", value: "0" });
        //     sitesListStore.sites.value.forEach((site, i) => {
        //       const indexStandardizer = 1;
        //       options.push({
        //         id: i + indexStandardizer,
        //         label: site.displayName || site.name,
        //         value: site.id.toString()
        //       });
        //     });
        //   }
        // } else {
        //   const { site } = usersStore.user.value;
        //   const siteOption = {
        //     id: site.id,
        //     label: site.displayName || site.name,
        //     value: site.id.toString()
        //   };
        //   options.push(siteOption);
        // }
        const user = store_4.usersStore.user.value || null;
        const showAllSites = store_4.usersStore.permissions.ReadPharmacies;
        const options = store_3.sitesListStore.sites.value.filter(site => showAllSites || site.id === (user === null || user === void 0 ? void 0 : user.site.id) || (user === null || user === void 0 ? void 0 : user.sites).includes(site.id))
            .map((site, i) => ({
            id: i + 1,
            label: site.displayName || site.name,
            value: String(site.id)
        }));
        if (true) {
            options.unshift({
                id: 0,
                label: "All Pharmacies",
                value: "0"
            });
        }
        return options;
    }
    // @observable
    // public financialWidget = React.createRef();
    async componentDidMount() {
        if (this.props.isFinancialPage) {
            this.periodData = this.props.periodData;
            this.periodDateRange = this.props.payPeriod;
            this.prevPeriodData = this.props.prevPeriodData;
            this.periodDateRange = this.props.prevPayPeriod;
            // console.log("period data in component did mount:", this.periodData);
            this.renderFinancialPeriodChart();
        }
        else {
            this.siteId = store_4.usersStore.user.value.siteId;
            await this.handleChangeSite(String(this.siteId));
            if (store_4.usersStore.user.value && store_4.usersStore.user.value.user) {
                await store_3.sitesListStore.loadSitesNoRelation();
            }
            await this.listFinancialData();
            this.renderFinancialChart();
        }
    }
    UNSAFE_componentWillReceiveProps(props) {
        if (props.periodData && props.payPeriod && props.prevPayPeriod && props.prevPeriodData) {
            this.periodData = props.periodData;
            this.periodDateRange = props.payPeriod;
            this.prevPeriodData = props.prevPeriodData;
            this.prevPeriodDateRange = props.prevPayPeriod;
            this.renderFinancialPeriodChart();
        }
    }
    render() {
        const { classes } = this.props;
        return (React.createElement("div", { className: "financial-widget widget" }, this.props.isFinancialPage ? (React.createElement("div", { className: "financial-widget__canvas-container" },
            React.createElement("canvas", { ref: "financialPeriodWidget", "aria-label": "financial period graph", role: "financial period graph" },
                React.createElement("p", null, "Your browser does not suppport the canvas element.")))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.header },
                React.createElement("div", { className: classes.btnContainer },
                    React.createElement(core_1.Typography, { variant: "title" }, "Current Pay Period"),
                    React.createElement(select_1.MaterialSelect, { className: "edit-order-header__select-site", options: this.availableOptions, required: true, searchable: true, label: "Pay Period", onSelect: this.handleChangePeriod, value: String(this.payPeriod) || "" })),
                store_4.usersStore.permissions.ViewPharmaciesFinancialWidget && (React.createElement("div", { className: classes.btnContainer },
                    React.createElement(core_1.Typography, { variant: "title" }, "Currently Viewing"),
                    React.createElement(select_1.MaterialSelect, { options: this.availableOptionsSites, required: true, searchable: true, className: "financial-widget-select-site", label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "" })))),
            React.createElement("div", { className: "financial-widget__canvas-container" },
                React.createElement("canvas", { ref: "financialWidget", "aria-label": "financial graph", role: "financial graph" },
                    React.createElement("p", null, "Your browser does not suppport the canvas element.")))))));
    }
};
__decorate([
    mobx_1.computed
], FinancialWidgetUnstyled.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], FinancialWidgetUnstyled.prototype, "availableOptionsSites", null);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "payPeriod", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "claimDataIndexToFill", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "claimDispensedDataIndexToFill", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "orderDataIndexToFill", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "myBarChart", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "siteIdArray", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "periodData", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "periodDateRange", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "prevPeriodData", void 0);
__decorate([
    mobx_1.observable
], FinancialWidgetUnstyled.prototype, "revPeriodDateRange", void 0);
__decorate([
    mobx_1.action
], FinancialWidgetUnstyled.prototype, "handleChangePeriod", void 0);
FinancialWidgetUnstyled = __decorate([
    mobx_react_1.observer
], FinancialWidgetUnstyled);
exports.FinancialWidget = core_1.withStyles(styles)(FinancialWidgetUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/financial-widget/financial-widget.tsx
// module id = 3351
// module chunks = 0